import { createContext, useContext } from 'react';
import { noop } from 'lodash';
import { QueryParamContextState } from 'modules/iterableGoals/types';
import { defaultTab } from '../constants';

export const initalQueryParamContextState = {
  goalId: 0,
  goalName: '',
  includeRevenue: false,
  includePrevious: false,
  tab: defaultTab,
  setTab: noop,
};

export const QueryParamContext = createContext<QueryParamContextState>(
  initalQueryParamContextState,
);

export const useQueryParamContext = () => useContext(QueryParamContext);
